export const ACTIVITY_TYPE_LABELS: Record<string, string> = {
  ev_charging: 'EV Charging Activity',
  gas_refill: 'Gas Refill',
  multistore: 'Multistore Purchases',
  food_court: 'Food Court Purchases',
  mall_charges: 'Shopping Mall Charges',
};

/** Display label for capture channel — same as stored value (lead_source). */
export function captureChannelLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return key;
}

export function activityTypeLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return ACTIVITY_TYPE_LABELS[key] || key;
}
